module.exports = __webpack_public_path__ + "gplus-share-7d2580e6beb9dfde005a.svg";